export default "__VITE_ASSET__CDvW$SqD__";